import { useEffect } from 'react';

const HubSpotForm = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.charset = "utf-8";
    script.type = "text/javascript";

    script.onload = () => {
      if (window.hbspt) {
        console.log('HubSpot script loaded, creating form...');
        window.hbspt.forms.create({
          region: "na1",
          portalId: "7797319",
          formId: "0f8557aa-be77-4f9d-b946-dc1de51d815a",
          target: "#hubspot-form",
          onFormReady: function($form) {
            setTimeout(() => {
              const iframe = document.querySelector('#hubspot-form iframe');
              if (iframe && iframe.contentDocument) {
                const style = iframe.contentDocument.createElement('style');
                style.innerHTML = `
                  body { margin: 0 !important; padding: 0 !important; }
                  form.hs-form { width: 100% !important; max-width: 100% !important; }
                  .hs-form-field { margin-bottom: 6px !important; }
                  .hs-input { 
                    padding: 6px 10px !important; 
                    font-size: 13px !important; 
                    height: 34px !important;
                    width: 100% !important;
                    box-sizing: border-box !important;
                  }
                  label { font-size: 12px !important; margin-bottom: 3px !important; display: block !important; }
                  .hs-richtext, .hs-richtext p { font-size: 11px !important; line-height: 1.4 !important; margin: 6px 0 !important; }
                  .hs-submit { margin-top: 10px !important; text-align: center !important; }
                  .hs-button { padding: 10px 24px !important; font-size: 14px !important; }
                  .legal-consent-container { margin-top: 8px !important; }
                  .hs-form-booleancheckbox { margin-bottom: 6px !important; }
                  .hs-form-booleancheckbox-display { 
                    font-size: 11px !important; 
                    line-height: 1.4 !important;
                    display: flex !important;
                    align-items: center !important;
                  }
                  .hs-form-booleancheckbox-display input[type="checkbox"] {
                    margin: 0 8px 0 0 !important;
                    flex-shrink: 0 !important;
                    width: auto !important;
                  }
                  .hs-form-booleancheckbox-display span {
                    flex: 1 !important;
                  }
                  fieldset { max-width: 100% !important; }
                `;
                iframe.contentDocument.head.appendChild(style);
              }
            }, 100);
          }
        });
      } else {
        console.error('HubSpot script did not load correctly.');
      }
    };

    script.onerror = () => {
      console.error('Error loading HubSpot script.');
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <div id="hubspot-form" style={{ width: '100%' }}></div>
    </div>
  );
};

export default HubSpotForm;
